import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { InfoLabelModule } from '@fundamental-ngx/core/info-label';
import {
  PopoverBodyComponent,
  PopoverComponent,
  PopoverControlComponent,
  PopoverModule,
} from '@fundamental-ngx/core/popover';
import { BreadcrumbBadge } from '@jukebox/common';

@Component({
  selector: 'app-breadcrumb-badge',
  imports: [
    InfoLabelModule,
    PopoverModule,
    PopoverBodyComponent,
    PopoverComponent,
    PopoverControlComponent,
  ],
  templateUrl: './breadcrumb-badge.component.html',
  styleUrl: './breadcrumb-badge.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BreadcrumbBadgeComponent {
  @Input({ required: true }) badge!: BreadcrumbBadge;
  @Input({ required: true }) id!: string;
  @Input({ required: true }) popoverId!: string;
}
